import effects from 'app/effects/effects'
import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as R from 'ramda'
import moment from 'moment'
import * as Actions from 'app/store/actions/conversation.actions'
import { TYPE_VOUCHER } from 'app/constants/messageType'
import { PLACE_SUBSCRIBED } from 'app/configs/statusConfigs'

export const NOTIFICATIONS_PAGE_SIZE = 10
export const FIRST_PAGE = 1
export const SINGLE_ITEM = 1

const dateDiff = (startDate, endDate) => {
  return moment(startDate).diff(moment(endDate))
}

const onCheckAdminOrSubscriber = (item) => {
  const adminMessage = item.admin_last_message
  const subscriberMessage = item.subscriber_last_message

  if (R.and(adminMessage, subscriberMessage)) {
    if (dateDiff(adminMessage.created, subscriberMessage.created) > 0) {
      return { person: item.admin, lastMessage: adminMessage }
    }
    return {
      person: item.subscriber,
      lastMessage: subscriberMessage,
    }
  }
  return R.isNil(subscriberMessage)
    ? { person: item.admin, lastMessage: adminMessage }
    : { person: item.subscriber, lastMessage: subscriberMessage }
}

export const ConversationStatus = {
  ONGOING: 'ONGOING',
  SUBSCRIBER_UNSUBSCRIBED: 'SUBSCRIBER_UNSUBSCRIBED',
  SUBSCRIBER_DELETED: 'SUBSCRIBER_DELETED',
}

const isSubscribed = R.flip(R.includes)(PLACE_SUBSCRIBED)

const toConversationStatus = R.cond([
  [R.isNil, R.always(ConversationStatus.SUBSCRIBER_DELETED)],
  [isSubscribed, R.always(ConversationStatus.ONGOING)],
  [R.T, R.always(ConversationStatus.SUBSCRIBER_UNSUBSCRIBED)],
])

export const mapDataConversationList = (data) => {
  return R.filter(
    (item) => R.not(R.isNil(item)),
    // eslint-disable-next-line array-callback-return
    R.map((item) => {
      if (R.isNil(item.notification)) return undefined

      const isRead = R.path(['subscriber_last_message', 'is_read'], item)
      return {
        historyId: R.prop('history_id')(item),
        subscriberId: R.path(['subscriber', 'place_subscriber_id'], item),
        title: R.compose(
          (translation) =>
            R.pathEq(['notification', 'type'], TYPE_VOUCHER)(item)
              ? R.prop('voucher_title', translation)
              : R.prop('title', translation),
          R.head,
          R.path(['notification', 'translations']),
        )(item),
        eventStatus: R.path(['notification', 'event_status'])(item),
        eventStartDate: R.path(['notification', 'start_time'])(item),
        eventEndDate: R.path(['notification', 'end_time'])(item),
        firstName: R.path(['subscriber', 'first_name'], item),
        lastName: R.path(['subscriber', 'last_name'], item),
        avatar: R.path(['subscriber', 'avatar'], item),
        dataLastMessage: onCheckAdminOrSubscriber(item),
        isRead: R.isNil(isRead) ? true : isRead,
        updated: R.prop('updated')(item),
        conversationStatus: R.compose(
          toConversationStatus,
          R.path(['subscriber', 'status']),
        )(item),
      }
    }, data),
  )
}

export const useConversation = () => {
  const dispatch = useDispatch()
  const {
    conversationListData,
    isLoading,
    hasMore,
    error,
    search,
    limit,
    lastKey,
    fetchedAt,
    fetchedType,
  } = useSelector(({ conversation }) => conversation)

  const refetchConversation = () => {
    dispatch(Actions.refetchConversation())
  }

  const apiFetchersCallback = useCallback((key, search, listData, archived) => {
    effects.apis
      .getConversationList({ search, limit, lastKey: key, archived })
      .then(({ data, meta }) => {
        if (R.isEmpty(data) && key === null) {
          dispatch(Actions.onFetchEmpty())
        } else {
          let conversationList = mapDataConversationList(data)

          if (listData.length + conversationList.length === meta.total) {
            dispatch(
              Actions.onFetchFinal(
                [...listData, ...conversationList],
                meta.last_key,
              ),
            )
          } else {
            dispatch(
              Actions.onFetchSuccess(
                [...listData, ...conversationList],
                meta.last_key,
              ),
            )
          }
        }
      })
      .catch((error) => {
        if (R.isNil(error.response)) {
          dispatch(Actions.onFetchFailure('network_error'))
        } else {
          dispatch(Actions.onFetchFailure(error.response))
        }
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (hasMore) {
      let archived = null
      if (fetchedType === 'archived') {
        archived = 1
      } else if (fetchedType === 'unsubscribed') {
        // archived = 1;
      }
      dispatch(Actions.onFetchInit())
      apiFetchersCallback(lastKey, search, conversationListData, archived)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchedAt])

  useEffect(() => {
    dispatch(Actions.updateHistoryId(null))
    dispatch(Actions.refetchConversation())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const loadMore = () => {
    dispatch(Actions.onFetchMore())
  }

  const removeConversation = (index) => {
    dispatch(Actions.refetchConversation())
    /*conversationListData.splice(index, 1);
    dispatch(Actions.onFetchInit());
    dispatch(
      Actions.onFetchSuccess(
        [...conversationListData],
        lastKey
      )
    );*/
  }

  return [
    {
      conversationData: conversationListData,
      isLoading: isLoading,
      fetchErrorList: error,
      loadMore,
      hasMore,
      removeConversation,
    },
    refetchConversation,
  ]
}
